export function ShowSuccessToast(message = "Sucesso!") {
  var toast = document.createElement("div");
  toast.className = "toast slide-in";
  toast.innerHTML = message;

  document.body.appendChild(toast);

  toast.style.cssText = `
        position: fixed;
        display: block; 
        bottom: 20px;
        left: 20px;
        z-index: 99999999;
        padding: 10px;
        border-radius: 5px;
        background-color: rgb(207 255 193);
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
    `;

  setTimeout(function () {
    document.body.removeChild(toast);
  }, 3000);
}
